// API Service for Static Pages and Contact Form

// API URL yapılandırması
const getApiBaseUrl = () => {
    // Environment variable varsa onu kullan
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    
    // Doğrudan API'ye istek gönder
    return 'https://api.utkanesim.com';
};

class ApiService {
    constructor() {
        this.baseURL = getApiBaseUrl();
    }

    /**
     * API isteği gönderir
     * @param {string} endpoint - API endpoint'i
     * @param {Object} options - Fetch options
     * @returns {Promise} - API response
     */
    async makeRequest(endpoint, options = {}) {
        const url = `${this.baseURL}/${endpoint}`;
        
        const defaultOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Origin': window.location.origin,
            },
            mode: 'cors',
            credentials: 'omit',
            ...options
        };

        try {
            console.log('Making API request to:', url);
            console.log('Request options:', defaultOptions);
            
            const response = await fetch(url, defaultOptions);
            
            console.log('Response status:', response.status);
            console.log('Response headers:', response.headers);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    }

    /**
     * Statik sayfa içeriğini getirir
     * @param {string} pageType - Sayfa tipi (about, privacy, contact)
     * @param {string} language - Dil kodu (tr, en, de)
     * @returns {Promise} - Sayfa verisi
     */
    async getStaticPage(pageType, language = 'tr') {
        try {
            const endpoint = `static-pages/${pageType}?language=${language}`;
            const response = await this.makeRequest(endpoint);
            return response;
        } catch (error) {
            console.error(`Error fetching ${pageType} page:`, error);
            throw error;
        }
    }

    /**
     * İletişim formu gönderir
     * @param {Object} formData - Form verileri
     * @returns {Promise} - Gönderim sonucu
     */
    async submitContactForm(formData) {
        try {
            const response = await this.makeRequest('contact', {
                method: 'POST',
                body: JSON.stringify(formData)
            });
            return response;
        } catch (error) {
            console.error('Error submitting contact form:', error);
            throw error;
        }
    }

    /**
     * API hatalarını kullanıcı dostu mesajlara çevirir
     * @param {Error} error - Hata objesi
     * @returns {string} - Kullanıcı dostu hata mesajı
     */
    handleError(error) {
        if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
            return 'Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin.';
        }
        
        if (error.message.includes('403')) {
            return 'Erişim reddedildi. Lütfen daha sonra tekrar deneyin.';
        }
        
        if (error.message.includes('404')) {
            return 'Sayfa bulunamadı. Lütfen daha sonra tekrar deneyin.';
        }
        
        if (error.message.includes('500')) {
            return 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.';
        }
        
        return 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';
    }
}

export default new ApiService(); 